import * as rmd from 'material-ui';
import React from 'react';

class Switcher extends React.Component {
    constructor(props, context) {
        super(props, context);

        var val = false;
        try {
            val = JSON.parse(props.value || props[props.propKey] || false);
        } catch (e) {
            val = false;
        }

        this.state = {
            value: val
        };
    }

    componentWillReceiveProps = nextProps => {
        var value = false;
        try {
            value = JSON.parse(nextProps.value);
        } catch (e) {
            value = false;
        }
        this.setState({ value });
    };

    onToggle = () => {
        let value = !this.state.value;
        this.setState({ value });
        return this.props.onChange(this.props.propKey, value);
    };

    render() {
        return (
            <div style={{ marginTop: 15 }}>
                <rmd.Toggle label={this.props.label} toggled={this.state.value} onToggle={this.onToggle} />
            </div>
        );
    }
}

export default Switcher;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/pickers/Switcher.js
 **/